/**
 * BrandingApplier — aplica o branding white-label do tenant (cores) no documento.
 *
 * Consome `usePublicBranding()` (GET /brand/{slug}/brand.json, endpoint anônimo/público) e
 * injeta as CSS custom properties derivadas (--bg-accent, --fg-on-accent, --brand-secondary,
 * etc.) no elemento raiz, fazendo as cores do tenant valerem em todo o portal.
 *
 * Antes consumia `useBranding()` (GET /v1/tenant/branding, [RequiresTenantAdmin]) — achado da
 * revisão adversarial do logo de tenant: um Viewer (a maioria dos usuários) recebia 403 e as
 * cores do tenant nunca eram aplicadas para ele, caindo no tema default em vez do branding do
 * tenant. `usePublicBranding()` não depende de papel nenhum.
 *
 * Deve ser montado dentro do contexto autenticado (Shell), pois depende do
 * QueryProvider e do token de sessão. Não renderiza UI (retorna null).
 */

import { useEffect } from "react";
import { usePublicBranding } from "./hooks.js";
import { applyBrandingCssVars } from "./branding.js";

/** Componente sem UI: aplica as CSS vars de branding quando o branding carrega. */
export function BrandingApplier(): null {
  const { branding } = usePublicBranding();

  useEffect(() => {
    if (branding) {
      applyBrandingCssVars(branding);
    }
  }, [branding]);

  return null;
}
